export function capitalize(str: string) {
	const capitalizeFirst = (word: string) => {
		return word.slice(0, 1).toUpperCase() + word.slice(1)
	}
	const capitalizedWord = str.split(' ').map(capitalizeFirst).join(' ')
	return capitalizedWord
}
